<template>
    <div class="bank-account-card">
        <div class="ah-info-data-list">
            <div class="item">
                <div class="label">帳戶類型</div>
                <div class="value">{{ data.accountType === 1 ? "本國帳戶" : "外國帳戶" }}</div>
            </div>
            <template v-if="data.accountType === 1">
                <div class="item">
                    <div class="label">銀行/分行</div>
                    <div class="value">
                        <div style="display: flex; gap: 5px">
                            <span>({{ data.bnK_BOO }})</span>
                            <span v-if="bankBranchName">{{ bankBranchName }}</span>
                            <span v-else>{{ bankName }}</span>
                        </div>
                        <div v-if="bankBranchName">分行代碼：{{ data.bnK_DOO }}</div>
                    </div>
                </div>
            </template>
            <template v-if="data.accountType === 2">
                <div class="item">
                    <div class="label">銀行名稱</div>
                    <div class="value">{{ data.abroadBankName }}</div>
                </div>
                <div class="item">
                    <div class="label">銀行/分行</div>
                    <div class="value">{{ data.swiftCode }}</div>
                </div>
            </template>
            <div class="item">
                <div class="label">戶名</div>
                <div class="value">{{ data.bnK_TPC }}</div>
            </div>
            <div class="item">
                <div class="label">帳號</div>
                <div class="value">{{ data.bnK_ACC }}</div>
            </div>
            <div v-if="data.note" class="item">
                <div class="label">備註</div>
                <div class="value">{{ data.note }}</div>
            </div>
            <div v-if="data.passbookDoc" class="item">
                <div class="label">存摺封面</div>
                <div class="value">
                    <el-image :src="data.passbookDoc" :previewSrcList="[data.passbookDoc]" class="doc-image" fit="contain" />
                </div>
            </div>
            <div v-if="data.filE_AGREE" class="item">
                <div class="label">匯款同意書</div>
                <div class="value">
                    <el-image :src="data.filE_AGREE" :previewSrcList="[data.filE_AGREE]" class="doc-image" fit="contain" />
                </div>
            </div>
        </div>
        <div class="actions">
            <el-button type="normal" size="mini" plain @click="onEdit">編輯</el-button>
            <el-button type="danger" size="mini" plain @click="onDelete">刪除</el-button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'bank-account-card',
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            bankList: [],
            bankBranchList: [],
        };
    },
    computed: {
        bankName() {
            return _.find(this.bankList, ['boo', this.data.bnK_BOO])?.nam;
        },
        bankBranchName() {
            return _.find(this.bankBranchList, ['doo', this.data.bnK_DOO])?.nam;
        },
    },
    mounted() {
        this.fetchBankList(this.data.bnK_BOO);
        this.fetchBankBranchList(this.data.bnK_BOO);
    },
    methods: {
        async fetchBankList(boo) {
            if (!boo) return;

            const resp = await this.$api({
                url: '/Tool/GetBankOptions',
                method: 'GET',
            });
            this.bankList = resp.data.options;
        },
        async fetchBankBranchList(boo) {
            if (!boo) return;

            const resp = await this.$api({
                url: `/Tool/GetBranchOptions?BOO=${boo}`,
                method: 'GET',
            });
            this.bankBranchList = resp.data.options;
        },
        onEdit() {
            this.$emit('edit');
        },
        onDelete() {
            this.$emit('delete');
        },
    },
};
</script>
<style lang="scss">
.bank-account-card {
    position: relative;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px 25px;
    line-height: 150%;
    box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;

    .ah-info-data-list {
        font-size: 10pt;
        >.item {
            >.label {
                color: #666;
                width: 100px;
            }
        }
    }

    .doc-image {
        max-width: 120px;
        border: 1px solid #eee;
    }
    >.actions {
        position: absolute;
        top: 16px;
        right: 16px;
    }
}
</style>
